import { Pauser } from "./Pauser";
export async function loadExternalPauseInteraction(engine, refresh = true) {
    await engine.addInteractor("externalPause", (container) => new Pauser(container), refresh);
}
